'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _colors = require('HubStyleTokens/colors');

var _getFeatureDescriptionKey = require('self-service-api/core/utilities/getFeatureDescriptionKey');

var _getFeatureDescriptionKey2 = _interopRequireDefault(_getFeatureDescriptionKey);

var _Hubs = require('self-service-api/constants/Hubs');

var Hubs = _interopRequireWildcard(_Hubs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableRow = _styledComponents2.default.tr.withConfig({
  displayName: 'ProductCatalogTableRow__TableRow'
})([':nth-child(even){background-color:', ';:hover{background-color:', ';}& > th{background-color:', ';}}:nth-child(odd){background-color:', ';:hover{background-color:', ';}& > th{background-color:', ';}}'], _colors.OLAF, _colors.OLAF, _colors.OLAF, _colors.GYPSUM, _colors.GYPSUM, _colors.GYPSUM);

var LeftHeaderCell = _styledComponents2.default.th.withConfig({
  displayName: 'ProductCatalogTableRow__LeftHeaderCell'
})(['height:40px;& > p{margin-left:20px;margin-bottom:0;font-weight:500;}text-align:center;width:18.75%;min-width:175px;:first-child{width:25%;text-align:left;}']);

var ProductCatalogTableRow = function ProductCatalogTableRow(_ref) {
  var featureId = _ref.featureId,
      children = _ref.children,
      hub = _ref.hub;
  return _react2.default.createElement(
    TableRow,
    { key: featureId },
    _react2.default.createElement(
      LeftHeaderCell,
      null,
      _react2.default.createElement(
        'p',
        { style: { cursor: 'help' } },
        _react2.default.createElement(
          _UITooltip2.default,
          {
            placement: 'right',
            title: _react2.default.createElement(_FormattedMessage2.default, {
              message: (0, _getFeatureDescriptionKey2.default)(featureId, hub)
            })
          },
          _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricing-pages.features.' + featureId + '.name'
          })
        )
      )
    ),
    children
  );
};

ProductCatalogTableRow.propTypes = {
  featureId: _react.PropTypes.string.isRequired,
  children: _react.PropTypes.node.isRequired,
  hub: _react.PropTypes.oneOf(Object.keys(Hubs).map(function (hubKey) {
    return Hubs[hubKey];
  })).isRequired
};

exports.default = ProductCatalogTableRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-catalog/ProductCatalogTableRow.js
// module id = 687
// module chunks = 3 4